class ESDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onOutsideClick = this.onOutsideClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('keyup', this.onKeyUp);
    if (this.dataset.closeOnOutsideClick === 'true') {
      document.addEventListener('click', this.onOutsideClick);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this.onKeyUp);
    if (this.dataset.closeOnOutsideClick === 'true') {
      document.removeEventListener('click', this.onOutsideClick);
    }
  }

  onKeyUp(evt) {
    if (evt.code === 'Escape' && this.details.hasAttribute('open')) {
      evt.stopPropagation();
      this.close();
      this.summary.focus();
    }
  }

  onOutsideClick(evt) {
    if (this.details.hasAttribute('open') && !this.contains(evt.target)) {
      this.close();
    }
  }

  open() {
    this.details.setAttribute('open', '');
  }

  close() {
    this.details.removeAttribute('open');
  }
}

if (!customElements.get('es-disclosure')) {
  customElements.define('es-disclosure', ESDisclosure);
}
